export enum ModalID {
  NEW_PORTFOLIO = "new-portfolio-modal",
  NEW_SECURITY = "new-security-modal",
  DELETE_SECURITY = "delete-security-modal",
  CHANGE_CONFIGURATION = "change-configuration-modal",
  UPLOAD_FEEDBACK_MODAL = "upload-feedback-modal",
  UPGRADE_MODAL = "upgrade-modal",
  CHANGELOG_MODAL = "changelog-modal",
}
